<!--
 * @@Author: MuYang
-->

<script>
import { initSchema, beforeCreateSchema, initValue, submitDataHandle, validator, createdEvent } from '../../utils/share'
import openEvent from '../mixin/open-event'
import staticParams from '../mixin/params'
import pageRules from '../mixin/page-rules'
import defaultValue from '../../utils/default-value'
import { cloneDeep } from 'lodash-es'
import {HEADER_PARAMS_KEYS} from 'fe-coms-share/paas/constants'

export default {
  name: 'page-edit',
  provide () {
    return {
      formData: this.formData,
      store: this.store,
      subMap: this.subRelevance
    }
  },
  mixins: [openEvent, staticParams, pageRules, defaultValue],
  props: {
    params: Object,
    pageRules: {
      type: Array,
      default () {
        return []
      }
    },
    // 业务配置
    config: {
      default: () => ({})
    },
    // 自定义对象数据权限
    menuApiName: {
      type: String,
      default: ''
    },
    // 弹窗相关配置
    popupConfig: {
      default: () => ({})
    },
    fetchSubData: {
      type: Function,
      default : () => {}
    }
  },
  data () {
    return {
      // 需要校验列表
      store: {
        popupConfig: this.popupConfig,
        tenantType: this.params.tenantType,
        objectApiName: this.params.objectApiName,
        layoutApiName: this.params.layoutApiName,
        saveRef: this.saveRef,
        fieldMap: () => this.fieldMap
      },
      // 保存提交从对象数据
      subRelevance: {},
      formData: {},
      pagination: {},
      schema: null,
      isLoad: false, // 加载完成
      // 准备状态
      readyState: {
        isSchema: false,
        isData: false
      },
      isAllVerify: false
    }
  },
  mounted () {
    this.getSchemaLayout()
  },
  // computed: {
  //   subSchema () {
  //     return this.schema?.subSchema || []
  //   }
  // },
  watch: {
    readyState: {
      async handler (val) {
        // 处理页面数据
        if (val.isSchema && val.isData) {
          await this.processSchema()
        }
      },
      deep: true
    }
  },
  methods: {
    // 获取schema
    async getSchemaLayout () {
      this._schema = await beforeCreateSchema(this.requestParams, this.headerParams, this.config)
      this.$emit('schemaLoad', this._schema)
      // 请求从对象数据
      await this.fetchSubData(this._schema)
      this.readyState.isSchema = true
    },
    async processSchema () {
      // 初始化schema
      this.schema = await initSchema(this._schema, {
        btnsEvent: createdEvent.call(this),
        pageType: 'edit',
        config: this.config,
        isForm: true
      })
      // 初始化值
      initValue(this.formData, this.objectApiName, this.fieldMap, this.isEdit)
      this._updateData(this.formData)
      this._initSaveSub(this.schema?.subSchema || [])
      this._initPageRules(this.schema.pageRule)
      this.initRelatePages(this.fieldMap[this.objectApiName])
      this.isLoad = true
      this.$nextTick(() => {
        this.$emit('loaded', this.schema)
      })
    },

    // 从对象存储列表
    _initSaveSub (subs = []) {
      const subRelevance = this.subRelevance
      const createdRow = this.defaultCreatedRow || {}
      subs.forEach(v => {
        this.$set(subRelevance, v.subObjectParamName, {
          dels: [],
          data: createdRow[v.subObjectParamName] || this.formData[v.subObjectParamName],
          fieldMap: this.fieldMap[v.objectApiName]
        })
      })
      // TODO 有tab时需要修改
      this.isAllVerify = subs.length > 0
    },

    // 提交
    async handleSubmit () {
      await this.submitVerify()
      const params = {
        data: this.getSubmitData(),
        isEdit: this.isEdit,
        layoutType: this.layoutType,
        headerParams: {
          ...this.headerParams,
          [HEADER_PARAMS_KEYS.menuApiName]: this.menuApiName
        }
      }
      return params
    },
    // form校验
    async validatorForm () {
      return new Promise((resolve, reject) => {
        this._getRef('form').validate((flag, error) => {
          if (!flag) {
            this.$nextTick(() => {
              document.querySelector('.edit-box .el-form-item.is-error').scrollIntoView({
                block: 'center',
                inline: 'center'
              })
            })
            reject(error)
          } else {
            resolve()
          }
        })
      })
    },
    // 验证
    async submitVerify () {
      await this.validatorForm()
      // if (this.isAllVerify) {
      //   await this.customValidator()
      // }
      await this.customValidator()
      return Promise.resolve('success')
    },
    
    async customValidator (subRelevance) {
      const {error, errorTabApiName} = await validator({
        mainRecord: {
          formData: this.formData,
          fieldMap: this.fieldMap[this.objectApiName]
        },
        subRelevance: subRelevance || this.subRelevance
      })
      if (error && error.length > 0) {
        // TODO 切换对应 之后再调用 form校验
        if (errorTabApiName) {
          this._getRef('tabs').forceTabChange(errorTabApiName)
        }
        this.$nextTick(async () => {
          this.subTurnPages(error)
          this.$nextTick(async () => {
            await this.validatorForm()
          })
        })
        return Promise.reject(error)
      }
    },
    // 根据错误信息跳转从对象页码
    subTurnPages (error) {
      const errMap = {}
      const sendTurn = (subObjectParamName, err) => {
        const {objectApiName} = this.schema.subSchema.find(v => v.subObjectParamName === subObjectParamName) || {}
        objectApiName &&
        this._getRef('masterRelation', objectApiName).updatePageByIndex(err.index)
      }
      error.forEach(v => {
        if (!errMap[v.subObjectParamName]) {
          errMap[v.subObjectParamName] = v
          sendTurn(v.subObjectParamName, v)
        }
      })
    },
    // 提交数据
    getSubmitData (subRelevance) {
      // 获取从对象数据
      return submitDataHandle({
        mainRecord: {
          formData: this.formData,
          fieldMap: this.fieldMap[this.objectApiName]
        },
        subRelevance: subRelevance || this.subRelevance,
        layoutType: this.layoutType,
        isEdit: this.isEdit,
        isPackage: this.region === 2
      })
    },

    // 提交选中行
    async getSubmitSelectData (params) {
      const rows = this.getSelection(params)
      if (rows.length === 0) {
        return {noSelect: true}
      }
      const subKey = params.subKey
      const subRelevance = cloneDeep(this.subRelevance)
      if (subKey) {
        subRelevance[subKey].data = rows
      }
      // 选中行出发自定义校验
      await this.customValidator(subRelevance)
      return this.getSubmitData(subRelevance)
    },

    // 内部校验
    _validateField (apiName) {
      this._getRef('form').validateField(apiName)
    },

    // 内部清空校验
    _clearValidateField (apiName) {
      this._getRef('form').clearValidate(apiName)
    },

    // 添加行
    _handleAddRow (objectApiName, rows, cb) {
      if (this.isMain(objectApiName)) { return }
      const curRef = this._getRef('masterRelation', objectApiName, cb)
      curRef && curRef.handleBatchAddLine(this.fieldMap[objectApiName], rows, cb)
    },
    // 删除
    _handleRemoveRow (objectApiName, row) {
      if (this.isMain(objectApiName)) { return }
      const curRef = this._getRef('masterRelation', objectApiName)
      curRef && curRef.handleDelLine(row)
    },
    // 批量删除
    handleBatchRemove ({objectApiName}) {
      if (this.isMain(objectApiName)) { return }
      const curRef = this._getRef('masterRelation', objectApiName)
      curRef && curRef.handleBatchDelete()
    }
  },
  render (h) {
    const { isLoad, schema } = this
    console.log(isLoad, schema, 'isLoad, schema')
    return (
      <div class='edit-box'>
        {
          isLoad ? (<render viewContent={schema?.nodes} />) : (<skeleton page='edit'></skeleton>)
        }
      </div>
    )
  }
}
</script>
